import { render, staticRenderFns } from "./sparkles.vue?vue&type=template&id=443c4d06&"
import script from "./sparkles.vue?vue&type=script&lang=js&"
export * from "./sparkles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports